@if (!isBetslipCleared) {
    <div class="clear-betslip-dialog_info-container">
        <div class="clear-betslip-dialog_title">{{ this.sitecoreData.multiRandomGenerator.ClearBetslipTitle }}</div>
        <div class="clear betslip-dialog_messages">
            <div class="clear-betslip-dialog_message">{{ this.sitecoreData.multiRandomGenerator.ClearBetslipExceedMessage }}</div>
            <div class="clear-betslip-dialog_message">{{ this.sitecoreData.multiRandomGenerator.ClearBetslipClearMessage }}</div>
        </div>
        <div class="clear-betslip-dialog_buttons">
            <button class="dialog-buttons" ds-button kind="tertiary" variant="outline" size="large" truncate="true" (click)="onClearBetslip()">
                {{ this.sitecoreData.multiRandomGenerator.ClearBetslipClearButton }}
            </button>
            <button class="dialog-buttons" ds-button kind="primary" variant="filled" size="large" (click)="onClose()">
                {{ this.sitecoreData.multiRandomGenerator.ClearBetslipOKButton }}
            </button>
        </div>
    </div>
} @else {
    <div class="clear-betslip-dialog_success-container">
        <div class="clear-betslip-dialog_messages">
            <vn-icon class="clear-betslip-check-icon" name="sports-check" size="30" />
            <div class="clear-betslip-dialog_message">{{ this.sitecoreData.multiRandomGenerator.ClearBetslipSuccessMessage }}</div>
        </div>
        <div class="clear-betslip-dialog_buttons">
            <button class="success-button" ds-button kind="primary" variant="filled" size="large" (click)="onClose()">
                {{ this.sitecoreData.multiRandomGenerator.ClearBetslipOKButton }}
            </button>
        </div>
    </div>
}
